import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f5f5;
  padding: 0;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: white;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h2 {
    margin: 0;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }

  .header-buttons {
    display: flex;
    gap: 12px;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  color: #01579b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(1, 87, 155, 0.1);
  }

  svg {
    font-size: 16px;
  }
`;

export const ProtocolDetail = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: white;
  margin: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }

  .status-badge {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .info-group {
    margin-bottom: 24px;

    p {
      margin: 8px 0;
      color: #555;
      font-size: 14px;
      line-height: 1.5;

      strong {
        color: #333;
        font-weight: 600;
      }
    }

    .method-detail {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 4px 8px;
      background: rgba(1, 87, 155, 0.1);
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
    }
  }

  h4 {
    margin: 24px 0 12px 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }

  .action-buttons {
    display: flex;
    justify-content: center;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #eee;

    .write-off-button {
      background: #4caf50;
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: background-color 0.2s;

      &:hover {
        background: ${shade(0.1, '#4caf50')};
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #666;

    p {
      margin-top: 16px;
      font-size: 14px;
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &.pendente {
    background: rgba(229, 57, 53, 0.1);
    color: #e53935;
    border: 1px solid rgba(229, 57, 53, 0.3);
  }

  &.concluido {
    background: rgba(0, 98, 41, 0.1);
    color: #006229;
    border: 1px solid rgba(0, 98, 41, 0.3);
  }

  &.cancelado {
    background: rgba(229, 57, 53, 0.1);
    color: #e53935;
    border: 1px solid rgba(229, 57, 53, 0.3);
  }
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  transition: background-color 0.2s;

  &:hover {
    background: #e9ecef;
  }

  .attachment-info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    svg {
      color: #6c757d;
      font-size: 16px;
    }

    span {
      color: #495057;
      font-size: 14px;
      word-break: break-all;
    }
  }

  .attachment-actions {
    display: flex;
    gap: 8px;

    button {
      background: none;
      border: none;
      padding: 6px;
      border-radius: 4px;
      color: #6c757d;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: rgba(1, 87, 155, 0.1);
        color: #01579b;
      }

      svg {
        font-size: 14px;
      }
    }
  }
`;
